import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";


export default function SubcontractorsRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.Subcontractor.Archive />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.Subcontractor.Archive />
            </Route>
            <Route path={ `${ path }/page/` } exact>
                <Pages.Subcontractor.Archive />
            </Route>
            <Route path={ `${ path }/create` } exact>
                <Pages.Subcontractor.Create />
            </Route>
            <Route path={ `${ path }/:id` }>
                { ({ match }) => <Pages.Subcontractor.Single match={ match } exact /> }
            </Route>
        </Switch>
    );
}
